module.exports = __webpack_public_path__ + "static/media/Fourth-Digital-Mattress-Tag.b1ca84cb.jpg";